const imageRemoteUrlObj = {
  AppleGiftCardSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/apple-giftcard500x322.webp`,
  NikeGiftCardSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/nike-giftcard500x322.webp`,
  ColumbiaGiftCardSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/columbia-giftcard500x322.webp`,
  ASOSGiftCardSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/asos-giftcard500x322.webp`,
  AmazonGiftCardSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/amazon-giftcard500x322.webp`,
  StarbucksGiftCardSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/starbucks-giftcard500x322.webp`,
  AdidasGiftCardSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/adidas-giftcard500x322.webp`,
  FootLockerGiftCardSm: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/footlocker-giftcard500x322.webp`,
}

export const giftcardData = [
  {
    key: "group1",
    offset: "right",
    image: [
      {
        src: imageRemoteUrlObj.AppleGiftCardSm,
        alt: "Image of a virtual gift card from Apple, featuring the iconic Apple logo.",
      },
      {
        src: imageRemoteUrlObj.NikeGiftCardSm,
        alt: "Image of a virtual gift card from Nike, showcasing the Nike logo and swoosh.",
      },
    ],
  },
  {
    key: "group2",
    offset: "left",
    image: [
      {
        src: imageRemoteUrlObj.ColumbiaGiftCardSm,
        alt: "Image of a virtual gift card from Columbia, displaying the Columbia logo.",
      },
      {
        src: imageRemoteUrlObj.ASOSGiftCardSm,
        alt: "Image of a virtual gift card from ASOS, featuring the ASOS logo.",
      },
    ],
  },
  {
    key: "group3",
    offset: "right",
    image: [
      {
        src: imageRemoteUrlObj.AmazonGiftCardSm,
        alt: "Image of a virtual gift card from Amazon, showcasing the Amazon logo.",
      },
      {
        src: imageRemoteUrlObj.StarbucksGiftCardSm,
        alt: "Image of a virtual gift card from Starbucks, featuring the Starbucks logo and signature mermaid icon.",
      },
    ],
  },
  {
    key: "group4",
    offset: "left",
    image: [
      {
        src: imageRemoteUrlObj.AdidasGiftCardSm,
        alt: "Image of a virtual gift card from Adidas, displaying the Adidas logo.",
      },
      {
        src: imageRemoteUrlObj.FootLockerGiftCardSm,
        alt: "Image of a virtual gift card from Foot Locker, showcasing the Foot Locker logo.",
      },
    ],
  },
]
